// extracted by mini-css-extract-plugin
export var pillWrapper = "_ow-0";
export var showOverflow = "_ow-1";